import { Box, Divider, Typography } from "@mui/material";


const OneLineStrip = () => (
  <>
    <Divider orientation='vertical' flexItem sx={{ color: 'white', border: '1px solid' }} />
    <Box sx={{ backgroundColor: '#8FAA30', mx: 'auto', padding: 3}}>
      <Typography  sx={{color: 'white', textAlign: 'center', fontSize: '1.5rem' }}>
        Transform your outdoor space with trusted, local landscapers. Get in touch for a free quote today.
      </Typography>
    </Box>
    <Divider orientation='vertical' flexItem sx={{ color: 'white', border: '1px solid' }} />
  </>
)

export default OneLineStrip